/*
    模块组件
    ChenYN

    说明
    帖子底部

    版本
    1.0

    传参
        userLike Number : 必填 是否点赞状态
        posts Number : 必填 评论数
        likes Number : 必填 点赞数
        likeFun Function : 非必填 点赞事件
        commentFun Function : 非必填 评论事件
        isCollect Boolean : 非必填  是否开启收藏模式
        userCollect Number : 非必填 用户收藏文章的id
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <forum-foot :commentFun="userComment" :likeFun="userLike" :isForumDetail="isForumDetail" :userFavorite="forumData.user_favorite" :userLike="forumData.user_like" :views="forumData.views" :posts="forumData.posts" :likes="forumData.likes" :isCollect="isCollect" :userCollect="forumData.favorite_id" :collectFun="collectFun"></forum-foot>
*/
<template>
    <div class="forum_foot" v-if="!isForumDetail">
        <div class="icon_box" @click.stop="likeBtn">
            <img v-if="userLike == 0" src="@/assets/images/atmosphere/like_d.png" alt="">
            <img v-else src="@/assets/images/atmosphere/like_a.png" alt="">
            <span class="num">{{countFormat(likes) || 0}}</span>
        </div>
        <div class="icon_box" @click.stop="commentBtn">
            <img src="@/assets/images/atmosphere/icon_message.png" alt="">
            <span class="num">{{countFormat(posts) || 0}}</span>
        </div>
        <div class="icon_box_see">
            <img src="@/assets/images/atmosphere/icon_see.png" alt="">
            <!-- <img v-else src="@/assets/images/atmosphere/icon_star.png" alt=""> -->
            <span class="num">{{countFormat(views) || 0}}</span>
        </div>
    </div>
    <div class="forum_foot_ForumDetail" v-else>
        <div class="icon_box" @click.stop="commentBtn">
            <img src="@/assets/images/atmosphere/icon_message.png" alt="">
            <span class="num">{{countFormat(posts) || 0}}</span>
        </div>
        <div class="icon_box" @click.stop="collectFun">
            <img v-if="userFavorite == 0" src="@/assets/images/atmosphere/icon_no_star.png" alt="">
            <img v-else src="@/assets/images/atmosphere/icon_star.png" alt="">
            <!-- <span class="num">{{userFavorite || 0}}</span> -->
        </div>
        <div class="icon_box" @click.stop="likeBtn">
            <img v-if="userLike == 0" src="@/assets/images/atmosphere/like_d.png" alt="">
            <img v-else src="@/assets/images/atmosphere/like_a.png" alt="">
            <span class="num">{{countFormat(likes) || 0}}</span>
        </div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import Util from '@/assets/js/lib/util';

export default defineComponent({
    name: 'ForumFoot',
    props: {
        userLike: {
            type: Number,
            default: 0
        },
        posts: {
            type: Number,
            default: 0
        },
        likes: {
            type: Number,
            default: 0
        },
        likeFun: {
            type: Function
        },
        commentFun: {
            type: Function
        },
        isCollect: {
            type: Boolean,
            default: false
        },
        userCollect:{
            type: Number,
            default: 0
        },
        collectFun: {
            type: Function
        },
        views: {
            type: Number,
            default: 0
        },
        isForumDetail: {
            type: Boolean,
            default: false
        },
        userFavorite: {
            type: Number,
            default: 0
        },
    },
    setup(props) {
        const state = reactive({
            util: new Util(),
        });
        const likeBtn = () => {
            if(props.likeFun){
                props.likeFun();
            }
        };
        const commentBtn = () => {
            if(props.commentFun){
                props.commentFun();
            }
        };
        const collectBtn = () => {
            if(props.collectFun){
                props.collectFun();
            }
        };

        const countFormat = (count) => {
            if(count) {
                let num = Number(count)
                if(num >= 10000) {
                    let numStr = (num/10000).toString();
                    const decimalIndex = numStr.indexOf('.');
                    if (decimalIndex !== -1) {
                        // 截取整数部分和小数点后第一位
                        return numStr.slice(0, decimalIndex + 2) + 'w';
                    } else {
                        // 如果没有小数部分，直接返回
                        return numStr + '.0w';
                    }
                }else {
                    return num
                }
            }else {
                return 0
            }
        }

        return {
            ...toRefs(state),
            likeBtn,
            commentBtn,
            collectBtn,
            countFormat
        };
    },
});
</script>
<style lang="less" scoped>
@import "./ForumFoot.less";
</style>
